import type { IDataSource } from "@/data/dao/service/BaseServiceDao";
import { VisibleEndUserProperties } from "@/data/model/Enums";
import { Misc } from "@/data/util/Misc";

import { i18n } from "@/portal/Trans";
import { Select } from "@/portal/formControls/Select";

export class VisibleEndUserPropertiesSelect {
    private allowedVisibleEndUserProperties: VisibleEndUserProperties;
    private visibleEndUserPropertiesSelect: Select<VisibleEndUserProperties>;

    constructor($element: JQuery) {
        this.allowedVisibleEndUserProperties =
            VisibleEndUserProperties.FirstNameShortLastName |
            VisibleEndUserProperties.Email |
            VisibleEndUserProperties.PhoneNumber |
            VisibleEndUserProperties.FirstNameLastName;

        const datasource: IDataSource<VisibleEndUserProperties> = {
            getData: this.getOptions.bind(this),
        };

        this.visibleEndUserPropertiesSelect = new Select(
            $element,
            datasource,
            undefined,
            false,
            i18n(`enums.VisibleEndUserProperties.${VisibleEndUserProperties[VisibleEndUserProperties.None]}`),
            undefined,
            true
        ) as Select<VisibleEndUserProperties>;
    }

    public setValues(visibleEndUserProperties: VisibleEndUserProperties | undefined) {
        const selectedValues: number[] = [];
        if (visibleEndUserProperties !== undefined) {
            Misc.eachEnum(VisibleEndUserProperties, (id) => {
                if (id == 0) return;
                if ((visibleEndUserProperties & id) === id) {
                    selectedValues.push(id);
                }
            });
        }

        this.visibleEndUserPropertiesSelect.setValues(selectedValues);
    }

    public setAllowedOptions(allowedEndUserProperties: VisibleEndUserProperties | undefined) {
        this.allowedVisibleEndUserProperties = allowedEndUserProperties ?? VisibleEndUserProperties.None;
        this.visibleEndUserPropertiesSelect.fetchData();
    }

    public getValue(): VisibleEndUserProperties {
        // Initialize the sum of the enum values.
        let enumValuesSum = VisibleEndUserProperties.None;

        // Retrieve the selected values from the select component. If no values are selected, default to an empty array.
        const selectedValues = this.visibleEndUserPropertiesSelect.getValues() ?? [];

        // Iterate over the selected values, parse each one to an integer, and add it to the sum.
        selectedValues.forEach((value) => {
            enumValuesSum += parseInt(value);
        });

        // Return the sum of the selected enum values.
        return enumValuesSum;
    }

    private async getOptions() {
        const availableOptions: any[] = [];

        Misc.eachEnum(VisibleEndUserProperties, (id, enumValName) => {
            if (id == 0) return;

            if ((this.allowedVisibleEndUserProperties & id) !== id) return;

            availableOptions.push({
                id: id,
                name: i18n(`enums.VisibleEndUserProperties.${enumValName}`),
            });
        });

        return {
            items: availableOptions,
            limit: 0,
            offset: 0,
            hasNext: false,
            hasPrev: false,
        };
    }
}
